<template>
  <div class="schedule max-content">
    <top :title="nav_title" :color="color"></top>
    <div class="detail">
      <div class="cell">
        <div class="head">
          <div class="left">
            <p class="name" v-if="scheduleDetails.session">
              {{ scheduleDetails.session.name }}
            </p>
            <p class="time" v-if="scheduleDetails.session">
              开始时间：<span>{{ scheduleDetails.session.start_at }}</span>
            </p>
          </div>
        </div>
        <div>
          <div class="more">
            <span class="time" v-if="scheduleDetails.start_at">{{ scheduleDetails.start_at }}-{{ scheduleDetails.end_at
              }}</span>
            <div class="name">{{ scheduleDetails.name }}</div>
            <p class="live-detail" v-if="meeting_id != 473">
              <span v-if="scheduleDetails.live_status != 3  && scheduleDetails.is_show_schedule && scheduleDetails.is_show_live" @click="
      goDetail(scheduleDetails.session.id, scheduleDetails.id)
      ">日程直播 <van-icon name="arrow" color="#666666" /></span>
            </p>
            <div class="speakers" v-if="(scheduleDetails.chairman_writers &&
      scheduleDetails.chairman_writers.length) ||
      (scheduleDetails.host_writers &&
        scheduleDetails.host_writers.length) ||
      (scheduleDetails.discussor_writers &&
        scheduleDetails.discussor_writers.length) ||
      (scheduleDetails.titles && scheduleDetails.titles.length)
      ">
              <div v-if="scheduleDetails.chairman_writers &&
      scheduleDetails.chairman_writers.length
      ">
                主席：
                <p v-for="name in scheduleDetails.chairman_writers" :key="name.id" @click="goExpertDetail(name.id)">
                  {{ name.name
                  }}<span v-if="name.company">({{ name.company }})</span>
                  <van-icon name="arrow" />
                </p>
              </div>
              <div v-if="scheduleDetails.host_writers &&
      scheduleDetails.host_writers.length
      ">
                主持专家：
                <p v-for="name in scheduleDetails.host_writers" :key="name.id" @click="goExpertDetail(name.id)">
                  {{ name.name
                  }}<span v-if="name.company">({{ name.company }})</span>
                  <van-icon name="arrow" />
                </p>
              </div>

              <div v-if="scheduleDetails.discussor_writers && scheduleDetails.discussor_writers.length">
              
                讨论专家：
                <p v-for="name in scheduleDetails.discussor_writers" :key="name.id" @click="goExpertDetail(name.id)">
                  {{ name.name
                  }}<span v-if="name.company">({{ name.company }})</span><van-icon name="arrow" />
                </p>
              </div>

              <div v-if="scheduleDetails.titles && scheduleDetails.titles.length">
                <div v-for="val in scheduleDetails.titles" :key="val.id">
                  {{ val.title }}:
                  <p v-for="name in val.writers" :key="name.id" @click="goExpertDetail(name.id)">
                    {{ name.name
                    }}<span v-if="name.company">({{ name.company }})</span><van-icon name="arrow" />
                  </p>
                </div>
              </div>

              <div v-if="scheduleDetails.auto_writers && scheduleDetails.auto_writers.length">
                <div v-for="(item, i) in scheduleDetails.auto_writers" :key="i">
                  {{ item.type_name }}：

                  <p v-for="name in item.writers" :key="name.id"
                    @click="goExpertDetail(name.id)">
                    {{ name.name
                    }}<span v-if="name.company">({{ name.company }})</span><van-icon name="arrow" />
                  </p>
                </div>
                <br />
              </div>
            </div>

            <div class="chapter" v-for="(ele, index) in scheduleDetails.details" :key="ele.id">
              <div class="main" :style="{
      'border-left-width':
        index == scheduleDetails.details.length - 1 ? '0px' : '2px'
    }">
                <div class="title">
                  {{ ele.name }}<span v-if="ele.video_url">(已生成录播)</span>
                </div>
                <div v-for="(writer, wi) in ele.writers" :key="writer.id">
                  <p @click="goExpertDetail(writer.id)">
                    <span> · </span>{{ writer.name }}<span v-if="writer.company">({{ writer.company }})</span><van-icon
                      name="arrow" />
                  </p>

                  <p v-if="chapter_id == 7878">
                    <span style="opacity: 0;"> · </span><span>{{ teams_1[wi] }}</span>
                  </p>
                  <p v-if="chapter_id == 7879">
                    <span style="opacity: 0;"> · </span><span>{{ teams_2[wi] }}</span>
                  </p>
                  <p v-if="chapter_id == 7880">
                    <span style="opacity: 0;"> · </span><span>{{ teams_3[wi] }}</span>
                  </p>
                  <p v-if="chapter_id == 7881">
                    <span style="opacity: 0;"> · </span><span>{{ teams_4[wi] }}</span>
                  </p>
                </div>
              </div>
              <div class="light" v-if="ele.state == 0">
                <div class="color-bg">· {{ ele.time }} ·</div>
                <div class="status">未开始</div>
              </div>
              <div class="light now" v-if="ele.state == 1">
                <div class="color-bg">· {{ ele.time }} ·</div>
                <div class="status">进行中</div>
              </div>
              <div class="light end" v-if="ele.state == 2">
                <div class="color-bg">· {{ ele.time }} ·</div>
                <div class="status">已结束</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Icon } from "vant";
import { MeetingScheduleDetails } from "../../../config/interface.js";
import Top from "../components/Top";

export default {
  components: {
    Top,
    Icon
  },
  data() {
    return {
      chapter_id: 0,
      meeting_id: 0,
      scheduleDetails: {},
      nav_title: "日程详情",
      color: "",
      teams_1: ['李维敏团队和殷敏毅团队', '薛冠华团队和叶猛团队', '孟庆友团队', '陈跃鑫团队'],
      teams_2: ['刘晓兵团队和叶开创团队和王瑞华团队', '梁卫团队和叶猛团队'],
      teams_3: ['李维敏团队和殷敏毅团队', '郭相江团队', '曾嵘团队和宋小军团队'],
      teams_4: ['刘晓兵团队和王瑞华团队', '薛冠华团队和梁卫团队和郭相江团队'],

    };
  },
  mounted() {
    this.chapter_id = this.$route.query.chapter_id;
    this.meeting_id = this.$route.query.meeting_id;
    this.sessionSchedule();
    if (this.meeting_id == 473) {
      this.color = "#0A318E";
    }
  },
  methods: {
    sessionSchedule() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: ""
      });
      const url = MeetingScheduleDetails;
      let params = {
        chapter_id: this.chapter_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        Toast.clear();
        if (res.code == 0) {
          var data = res.data;
          this.scheduleDetails = data;
          if (res.data.theme_color_hex) {
              this.color = res.data.theme_color_hex
            } else {
              this.color = '#901D22'
            }
          this.scheduleDetails.start_at = this.scheduleDetails.start_at
            .split(" ")[1]
            .substring(0, 5);
          this.scheduleDetails.end_at = this.scheduleDetails.end_at
            .split(" ")[1]
            .substring(0, 5);
        }
      });
    },
    goDetail(parallel_session_id, id) {
      this.$router.push({
        path: "/vascularNews/meeting/liveDetail",
        query: {
          meeting_id: this.meeting_id,
          id: parallel_session_id,
          chapter_id: id
        }
      });
    },
    goExpertDetail(id) {
      this.$router.push({
        path: "/vascularNews/expert/detail",
        query: { meeting_id: this.meeting_id, writer_id: id }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schedule {
  .detail {
    padding: 0 15px;

    .cell {
      background: white;
      margin: 15px 0;
      border-radius: 10px;
    }

    .head {
      display: flex;
      padding: 15px;

      .left {
        width: 100%;

        .name {
          line-height: 19px;
          // height: 19px;
          margin-bottom: 13px;
          font-size: 16px;
          color: #1c1c1c;
        }

        .time {
          line-height: 14px;
          color: #666666;
          font-size: 12px;
        }
      }
    }

    .more {
      padding: 15px;
      border-top: 1px solid #ebebeb;

      .time {
        height: 20px;
        border-radius: 10px;
        background: #ffe6e7;
        line-height: 20px;
        color: #901d22;
        font-size: 14px;
        margin: 10px 0;
        padding: 0 10px;
      }

      .name {
        line-height: 22px;
        font-size: 16px;
        color: #131313;
        margin: 10px 0;
      }

      .live-detail {
        color: #131313;
        font-size: 13px;
        line-height: 18px;
        text-align: right;
        margin-bottom: 15px;
      }

      .speakers {
        background: #f7f7f7;
        border-radius: 5px;
        padding: 15px 10px;
        color: #901d22;
        font-size: 15px;
        line-height: 21px;
        margin-bottom: 20px;

        &>div{
          margin-bottom:15px;
        }
        &>div:last-child{
          margin-bottom:0;
        }
        p {
          color: #131313;
          font-size: 13px;
          margin-top: 5px;
          line-height: 18px;
        }
      }

      .chapter {
        position: relative;

        .title {
          font-size: 14px;
          color: #131313;
          margin-bottom: 13px;
          line-height: 17px;
        }

        p {
          color: #666666;
          font-size: 12px;
          line-height: 14px;
        }

        .main {
          margin-left: 26px;
          padding-left: 45px;
          border-left: 2px dashed #e4e4e4;
          padding-bottom: 40px;
        }

        .main.last {
          border: 0;
          padding-bottom: 10px;
        }
      }

      .light {
        border-radius: 3px;
        width: 57px;
        font-size: 12px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;

        .color-bg {
          background: linear-gradient(90deg, #4c82e3 0%, #204ea1 100%);
          color: white;
          line-height: 23px;
          white-space: nowrap;
        }

        .status {
          background: #e2ecff;
          color: #204ea1;
          line-height: 24px;
        }
      }

      .light.now {
        .color-bg {
          background: linear-gradient(90deg, #c33e47 0%, #901d22 100%);
        }

        .status {
          background: #ffebec;
          color: #901d22;
        }
      }

      .light.end {
        .color-bg {
          background: linear-gradient(90deg, #b7b7b7 0%, #929292 100%);
        }

        .status {
          background: #f7f7f7;
          color: #999999;
        }
      }
    }
  }
}

.expert {

  // display: flex;
  img {
    width: 18px;
  }

  span {
    margin-left: 5px;
    margin-right: 5px;
    // color:$color-black;
    line-height: 22px;
    font-size: 12px;
  }

  p {
    flex: 1;
    text-align: justify;
    font-size: 12px;
    // color:#999;
    line-height: 22px;
  }

  .text-top {
    vertical-align: top;
    margin: 0 5px 0 2px;
  }

  .names {
    margin: 0 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/ScheduleDetail.vue